import { IMensagem } from '@/interfaces/IMensagem';
import Config from '@/model/Config';
import Profissional from '@/model/Profissional';
import Usuario from '@/model/Usuario';
import { createStore } from 'vuex';

export const store = createStore({
  state: {
    mensagens: [] as IMensagem[],
    config: Object() as Config,
    usuario: Object() as Usuario,
    profissional: Object() as Profissional,
    token: String()
  },
  getters: {
    getMensagens(state) {
      return state.mensagens;
    },
    getConfig(state) {
      return state.config;
    },
    getUsuario(state) {
      return state.usuario;
    },
    getProfissional(state) {
      return state.profissional;
    },
    getToken(state) {
      return state.token;
    }
  },
  mutations: {
    setMensagens(state, newValue: IMensagem) {
      state.mensagens.push(newValue);
    },
    popMensagens(state, pId: string) {
      state.mensagens = state.mensagens.filter(function (estado) { return estado.Id != pId; });
    },
    setConfig(state, value) {
      state.config = value;
    },
    setUsuario(state, value) {
      state.usuario = value;
    },
    setProfissional(state, value) {
      state.profissional = value;
    },
    setToken(state, value) {
      state.token = value;
    }
  },
  actions: {
    changeMensagens(context, value: IMensagem) {
      context.commit('setMensagens', value);
    },
    deleteMensagens(context, pId: string) {
      context.commit('popMensagens', pId);
    }
  },
  modules: {
  }
});